import Badge, { BadgeProps } from '@repo/ui/badge'

import useTranslate from '../../lib/hooks/use-translate'
import {
  getOlStaffQualificationLabel,
  StaffQualificationEnum,
  staffQualificationEnumMapping
} from '../../lib/types/enums/staff/staff-qualifications.enum'

type QualificationBadgeProps = {
  qualification: StaffQualificationEnum
  // Foreign OL spaces use their own wording for qualifications
  olLabel?: boolean
} & Omit<BadgeProps, 'text' | 'color' | 'textColor' | 'variant'>

export const QualificationBadge = ({
  qualification,
  olLabel,
  ...props
}: QualificationBadgeProps) => {
  const { t } = useTranslate()
  const { label, color } = staffQualificationEnumMapping[qualification]

  return (
    <Badge
      text={t(olLabel ? getOlStaffQualificationLabel(qualification) : label)}
      color={color.background}
      textColor={color.text}
      {...props}
    />
  )
}

type QualificationTagsProps = {
  qualifications: StaffQualificationEnum[]
} & Omit<QualificationBadgeProps, 'qualification'>

export const QualificationTags = ({ qualifications, ...props }: QualificationTagsProps) => {
  if (qualifications.length === 0) return <span>-</span>

  return (
    <div className={'flex flex-wrap py-3 gap-1'}>
      {qualifications.map((qualification) => (
        <QualificationBadge key={qualification} qualification={qualification} {...props} />
      ))}
    </div>
  )
}
